<template>
    <div class="jzart-mask" v-show="isShow">
        <div class="jzart jzart-anim jzart-iframe"
             style="margin-top: -200px; margin-left: -250px; width: 500px; height: 200px;">
            <div class="jzart-top" style="cursor: move;">
                <a class=" jzart-ico jzart-top-close jzart-top-close1" @click="hide" title="关闭"></a>
                <div class="jzart-top-title" v-if="type===1">积分下载</div>
                <div class="jzart-top-title" v-else>会员下载</div>
            </div>
            <div class="m-pop" v-if="type===1">

                <div class="m-viewapi f-tac">
                    当前积分：<strong class="f-corg">{{userpoints}}</strong>&#8195;&#8195;&#8195;&#8195;所需积分：{{point}}
                </div>
                <div class="m-btns">
                    <a v-show="continueshow" class="u-button primary" :href="'/content/download/' + pkid" @click="downlaod">继续下载</a>
                    <a v-show="rechargeshow" class="u-button primary" href="/user/recharge.html">充值
                    </a>
                </div>
            </div>
            <div class="m-pop" v-else>
                <div class="m-viewapi f-tac">
                    {{contentmsg}}
                </div>
                <div class="m-btns">
                    <a class="u-button primary" href="/user/equity.html">充值
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    const defaultPostParam = {
        headers: {
            'content-type': 'application/json;charset=UTF-8'
        },
    };
    let p = Object.assign(defaultPostParam);
    export default {
        name: 'popuper',
        props: {},
        data() {
            return {
                pkid:"",
                userpoints: "",
                point: "",
                sttext: "",
                isShow: false,
                continueshow: false,
                rechargeshow: false,
                type: '',
                contentmsg:''
            };
        },
        mounted() {
        },
        methods: {
            async downlaod() {
                this.isShow=false;
            },

            show(e) {
                console.log(e);
                if (e) {
                    this.userpoints = e.userpoints;
                    this.point = e.point;
                    this.pkid = e.pkid;
                    this.type = e.type;
                    if(e.type === "2"){
                        this.contentmsg = "请充值报告大会员或者高级大会员！";//资源中心
                    }else{
                        this.contentmsg = "请充值数据大会员或者高级大会员！";//数据可视化
                    }
                    console.log(parseInt(e.userpoints));
                    if (parseInt(e.userpoints) >= parseInt(e.point)) {
                        this.continueshow = true;
                    } else {
                        this.rechargeshow = true;
                    }
                }
                this.isShow = true;
            },
            hide() {
                this.isShow = false;
            }
        }
    };
</script>
